import React, { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import {
    Plus,
    Dash

} from "react-bootstrap-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxes, faMoneyBillWave, faWarehouse } from "@fortawesome/free-solid-svg-icons";

const ProductCard = ({
    product,
    onClick
}) => {
    const [quantity, setQuantity] = useState(1);
    const increaseHoldTimerRef = useRef(null);
    const increaseRepeatTimerRef = useRef(null);
    const increaseHoldingRef = useRef(false);

    const decreaseHoldTimerRef = useRef(null);
    const decreaseRepeatTimerRef = useRef(null);
    const decreaseHoldingRef = useRef(false);
    const [maxCount, setMaxCount] = useState(0);

    /*
     * اگر ProductCard برای محصول دیگری استفاده شود،
     * تعداد دوباره از 1 شروع می‌شود.
     */
    const productId =
        product?.id ??
        product?.ID ??
        product?.productId;


    useEffect(() => {
        setQuantity(1);
        setMaxCount(Math.max(Number(product?.CountInStorage ?? 0), 0));
    }, [productId]);

    const getProductName = () => {
        return (
            product?.name ??
            product?.Name ??
            product?.productName ??
            product?.ProductName ??
            "-"
        );
    };

    const getProductModel = () => {
        return (
            product?.model ??
            product?.Model ??
            product?.productModel ??
            product?.ProductModel ??
            "-"
        );
    };

    const getProductPrice = () => {
        return (
            product?.price ??
            product?.Price ??
            product?.productPrice ??
            product?.ProductPrice ??
            0
        );
    };

    const getProductImage = () => {
        return (
            product?.imageUrl ??
            product?.ImageUrl ??
            product?.image ??
            product?.Image ??
            product?.productImage ??
            product?.ProductImage ??
            null
        );
    };

    const formatPrice = (value) => {
        if (
            value === null ||
            value === undefined ||
            value === ""
        ) {
            return "-";
        }

        const numericValue = Number(value);

        if (Number.isNaN(numericValue)) {
            return value;
        }

        return `${numericValue.toLocaleString("fa-IR")}`;
    };

    const handleCardClick = () => {
        if (typeof onClick === "function") {
            onClick(product, quantity);
        }
    };


    const increaseQuantity = () => {

        setQuantity(prev => Math.min(maxCount, prev + 1));
    };

    const decreaseQuantity = () => {
        setQuantity(prev => Math.max(1, prev - 1));
    };


    // =========================
    // Increase
    // =========================

    const handleIncreaseMouseDown = (e) => {
        e.stopPropagation();

        increaseHoldingRef.current = false;

        increaseHoldTimerRef.current = setTimeout(() => {
            increaseHoldingRef.current = true;

            increaseQuantity();

            increaseRepeatTimerRef.current = setInterval(() => {
                increaseQuantity();
            }, 150);

        }, 2000);
    };

    const handleIncreaseMouseUp = (e) => {
        e.stopPropagation();

        clearTimeout(increaseHoldTimerRef.current);
        clearInterval(increaseRepeatTimerRef.current);

        increaseHoldTimerRef.current = null;
        increaseRepeatTimerRef.current = null;
    };

    const handleIncreaseClick = (e) => {
        e.stopPropagation();

        if (!increaseHoldingRef.current) {
            increaseQuantity();
        }

        increaseHoldingRef.current = false;
    };


    // =========================
    // Decrease
    // =========================

    const handleDecreaseMouseDown = (e) => {
        e.stopPropagation();

        decreaseHoldingRef.current = false;

        decreaseHoldTimerRef.current = setTimeout(() => {
            decreaseHoldingRef.current = true;

            decreaseQuantity();

            decreaseRepeatTimerRef.current = setInterval(() => {
                decreaseQuantity();
            }, 150);

        }, 2000);
    };

    const handleDecreaseMouseUp = (e) => {
        e.stopPropagation();

        clearTimeout(decreaseHoldTimerRef.current);
        clearInterval(decreaseRepeatTimerRef.current);

        decreaseHoldTimerRef.current = null;
        decreaseRepeatTimerRef.current = null;
    };

    const handleDecreaseClick = (e) => {
        e.stopPropagation();

        if (!decreaseHoldingRef.current) {
            decreaseQuantity();
        }

        decreaseHoldingRef.current = false;
    };


    const handleDecrease = (event) => {
        event.stopPropagation();

        setQuantity((previous) =>
            Math.max(1, previous - 1)
        );
    };

    const handleQuantityClick = (event) => {
        event.stopPropagation();
    };

    const productName = getProductName();
    const productModel = getProductModel();
    const productPrice = getProductPrice();
    const productImage = getProductImage();

    return (
        <div
            className="product-card"
            onClick={handleCardClick}
            role="button"
            tabIndex={0}
        >
            <div className="product-card-content">

                {/* اطلاعات محصول */}
                <div className="product-card-info">

                    <div
                        className="product-card-name"
                        title={productName}
                    >
                        {productName}
                    </div>

                    <div
                        className="product-card-model"
                        title={productModel}
                    >
                        {productModel}
                    </div>
                    <div
                        className="product-card-code"
                    >
                        {product?.KalaCode ?? ""}
                    </div>

                    <div className="product-card-price tooltipBtn" data-tooltip="بهای کالا">
                        <FontAwesomeIcon icon={faMoneyBillWave} className="product-card-icons" />
                        {formatPrice(productPrice)}
                    </div>
                    <div className="product-card-storage tooltipBtn" data-tooltip={product.StorageName}>
                        <FontAwesomeIcon icon={faWarehouse} className="product-card-icons" />
                        <label className="product-card-storage-label" >
                            {product.StorageName}
                        </label>
                    </div>
                    <div className="product-card-inventory tooltipBtn" data-tooltip="موجودی در انبار">
                        <FontAwesomeIcon icon={faBoxes} className="product-card-icons" />
                        {product.CountInStorage}
                    </div>

                    <div
                        className="product-quantity"
                        onClick={handleQuantityClick}
                    >
                        <Button
                            variant="light"
                            className="quantity-button"
                            onMouseDown={handleDecreaseMouseDown}
                            onMouseUp={handleDecreaseMouseUp}
                            onMouseLeave={handleDecreaseMouseUp}
                            onClick={handleDecreaseClick}
                            aria-label="کاهش تعداد"
                        >
                            <Dash />
                        </Button>

                        <span className="quantity-value">
                            {quantity}
                        </span>

                        <Button
                            variant="light"
                            className="quantity-button"
                            onMouseDown={handleIncreaseMouseDown}
                            onMouseUp={handleIncreaseMouseUp}
                            onMouseLeave={handleIncreaseMouseUp}
                            onClick={handleIncreaseClick}
                            aria-label="افزایش تعداد"
                        >
                            <Plus />
                        </Button>
                    </div>

                </div>

                {/* عکس محصول */}
                <div className="product-card-image-container">

                    {productImage ? (
                        <img
                            src={productImage}
                            alt={productName}
                            className="product-card-image"
                            onError={(event) => {
                                event.currentTarget.style.display = "none";

                                const parent =
                                    event.currentTarget.parentElement;

                                if (parent) {
                                    parent.classList.add(
                                        "product-image-error"
                                    );
                                }
                            }}
                        />
                    ) : (
                        <div className="product-card-no-image">
                            بدون عکس
                        </div>
                    )}

                </div>

            </div>
        </div>
    );
};

export default ProductCard;
